import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconPhotoCamera48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="photo camera">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.5616 11H2V41H46V11H33.4384L32.4384 7L15.5616 7L14.5616 11ZM13.6213 6.51493C13.8439 5.62459 14.6438 5 15.5616 5H32.4384C33.3562 5 34.1561 5.62459 34.3787 6.51493L35 9H46C47.1046 9 48 9.89543 48 11V41C48 42.1046 47.1046 43 46 43H2C0.895432 43 0 42.1046 0 41V11C0 9.89543 0.895431 9 2 9H13L13.6213 6.51493Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 35C28.9706 35 33 30.9706 33 26C33 21.0294 28.9706 17 24 17C19.0294 17 15 21.0294 15 26C15 30.9706 19.0294 35 24 35ZM24 37C30.0751 37 35 32.0751 35 26C35 19.9249 30.0751 15 24 15C17.9249 15 13 19.9249 13 26C13 32.0751 17.9249 37 24 37Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 19C9.10457 19 10 18.1046 10 17C10 15.8954 9.10457 15 8 15C6.89543 15 6 15.8954 6 17C6 18.1046 6.89543 19 8 19ZM8 21C10.2091 21 12 19.2091 12 17C12 14.7909 10.2091 13 8 13C5.79086 13 4 14.7909 4 17C4 19.2091 5.79086 21 8 21Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconPhotoCamera24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="photo camera">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.14645 2.43934C8.42775 2.15803 8.80928 2 9.20711 2H14.7845C15.1972 2 15.5916 2.17003 15.875 2.47006L17.431 4.11765H22.5C23.3284 4.11765 24 4.78922 24 5.61765V20.5C24 21.3284 23.3284 22 22.5 22H1.5C0.671571 22 0 21.3284 0 20.5V5.5C0 4.67157 0.671573 4 1.5 4H6.58579L8.14645 2.43934ZM9.41421 4L7.85355 5.56066C7.57225 5.84196 7.19072 6 6.79289 6H2V20H22V6.11765H17.2155C16.8028 6.11765 16.4084 5.94762 16.125 5.64758L14.569 4H9.41421Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16ZM12 18C14.7614 18 17 15.7614 17 13C17 10.2386 14.7614 8 12 8C9.23858 8 7 10.2386 7 13C7 15.7614 9.23858 18 12 18Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M6 9C6 9.55228 5.55228 10 5 10C4.44772 10 4 9.55228 4 9C4 8.44772 4.44772 8 5 8C5.55228 8 6 8.44772 6 9Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconPhotoCamera16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="photo camera">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.14645 1.43934C5.42775 1.15803 5.80928 1 6.20711 1H9.79289C10.1907 1 10.5722 1.15804 10.8536 1.43934L12.4142 3H14.5C15.3284 3 16 3.67157 16 4.5V13.5C16 14.3284 15.3284 15 14.5 15H1.5C0.671572 15 0 14.3284 0 13.5V4.5C0 3.67157 0.671573 3 1.5 3H3.58579L5.14645 1.43934ZM6.41421 3L4.85355 4.56066C4.57225 4.84196 4.19072 5 3.79289 5H2V13H14V5H12.2071C11.8093 5 11.4278 4.84197 11.1464 4.56066L9.58579 3H6.41421Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 10C8.55228 10 9 9.55228 9 9C9 8.44772 8.55228 8 8 8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10ZM8 12C9.65685 12 11 10.6569 11 9C11 7.34315 9.65685 6 8 6C6.34315 6 5 7.34315 5 9C5 10.6569 6.34315 12 8 12Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M5 7C5 7.55228 4.55228 8 4 8C3.44772 8 3 7.55228 3 7C3 6.44772 3.44772 6 4 6C4.55228 6 5 6.44772 5 7Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
